import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

const EMPTY = { current_password: "", new_password: "", confirm: "" };
const FIELDS = [["current_password", "currentPassword"], ["new_password", "newPassword"], ["confirm", "confirmPassword"]];

export const ChangePasswordDialog = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return setError(t("passwordMismatch"));
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success(t("passwordChanged"));
      setOpen(false);
    } catch (err) { setError(errMsg(err)); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setForm(EMPTY); setError(""); }}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" data-testid="change-password-btn"><KeyRound className="w-4 h-4" /><span className="hidden lg:inline">{t("changePassword")}</span></Button>
      </DialogTrigger>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>{t("changePassword")}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {FIELDS.map(([k, l]) => (
            <div key={k} className="space-y-1.5"><Label>{t(l)}</Label>
              <Input type="password" dir="ltr" data-testid={`cp-${k}-input`} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} required minLength={k === "current_password" ? undefined : 6} /></div>
          ))}
          {error && <p className="text-sm text-rose-600" data-testid="cp-error">{error}</p>}
          <DialogFooter><Button type="submit" data-testid="cp-submit-btn">{t("save")}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
